'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var emitter = new _events2.default();

  var renderBuffer = {};

  return {
    scatterer: {
      unmount: function unmount(componentName) {
        emitter.emit('unmount:' + componentName);
      },

      render: function render(componentName, data, handlerNames, context) {
        emitter.emit('render:' + componentName, data, handlerNames, context);
        renderBuffer['render:' + componentName] = [data, handlerNames, context];
      },

      addHandlerListener: function addHandlerListener(componentName, handlerName, cb) {
        var eventName = 'handle:' + componentName + ':' + handlerName;
        emitter.on(eventName, cb);
        return function () {
          return emitter.removeListener(eventName, cb);
        };
      }
    },

    materializer: {
      addUnmountListener: function addUnmountListener(componentName, cb) {
        var eventName = 'unmount:' + componentName;
        emitter.on(eventName, cb);
        return function () {
          return emitter.removeListener(eventName, cb);
        };
      },
      renderBuffer: renderBuffer,
      addRenderListener: function addRenderListener(componentName, cb) {
        var eventName = 'render:' + componentName;
        emitter.on(eventName, cb);
        return function () {
          return emitter.removeListener(eventName, cb);
        };
      },

      handle: function handle(componentName, handlerName, args) {
        return emitter.emit('handle:' + componentName + ':' + handlerName, args);
      }
    }
  };
};